module.exports = __webpack_public_path__ + "img/packages/h4.be0c66.png";